module.exports = __webpack_public_path__ + "static/9-035306965533e7d68fb9fe05e1fe8a91.jpeg";